
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M5 2C3.89543 2 3 2.89543 3 4V20C3 21.1046 3.89543 22 5 22H13.8096C12.6888 20.8321 12 19.2465 12 17.5C12 13.9101 14.9101 11 18.5 11C19.0163 11 19.5185 11.0602 20 11.1739V4C20 2.89543 19.1046 2 18 2H5ZM17 7H6V9H17V7ZM6 12H10V14H6V12Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M21.125 14.75C21.6082 14.75 22 14.3582 22 13.875C22 13.3918 21.6082 13 21.125 13C20.8011 13 20.5184 13.176 20.3671 13.4375H17.625C16.4169 13.4375 15.4375 14.4169 15.4375 15.625C15.4375 16.8331 16.4169 17.8125 17.625 17.8125H17.7421C17.8934 18.074 18.1761 18.25 18.5 18.25C18.8239 18.25 19.1066 18.074 19.2579 17.8125H19.375C20.0999 17.8125 20.6875 18.4001 20.6875 19.125C20.6875 19.8499 20.0999 20.4375 19.375 20.4375H16.6329C16.4816 20.176 16.1989 20 15.875 20C15.3918 20 15 20.3918 15 20.875C15 21.3582 15.3918 21.75 15.875 21.75C16.1989 21.75 16.4816 21.574 16.6329 21.3125H19.375C20.5831 21.3125 21.5625 20.3331 21.5625 19.125C21.5625 17.9169 20.5831 16.9375 19.375 16.9375H19.2579C19.1066 16.676 18.8239 16.5 18.5 16.5C18.1761 16.5 17.8934 16.676 17.7421 16.9375H17.625C16.9001 16.9375 16.3125 16.3499 16.3125 15.625C16.3125 14.9001 16.9001 14.3125 17.625 14.3125H20.3671C20.5184 14.574 20.8011 14.75 21.125 14.75Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowCallPageContainerFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
